import { useQuery } from "@tanstack/react-query";
import { getProjectsAttributes } from "@/services/api.js";
import { reactQueryCacheAndRefetchOptions } from "@";

// Hook for fetching project attributes based on project IDs
export const useProjectsAttributesQuery = (projectIds = []) => {
  return useQuery({
    queryKey: ["projects-attributes", projectIds],
    queryFn: async () => {
      const options = await getProjectsAttributes(projectIds);
      return options || [];
    },
    enabled: projectIds.length > 0,
    ...reactQueryCacheAndRefetchOptions,
  });
};